module.exports = __webpack_public_path__ + "img/home_8.528601d9.jpg";